import { render, staticRenderFns } from "./ViewComponenteShow.vue?vue&type=template&id=56cf8e88&scoped=true&"
import script from "./ViewComponenteShow.vue?vue&type=script&lang=js&"
export * from "./ViewComponenteShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf8e88",
  null
  
)

export default component.exports